import {
  AppBaseStore,
  AuthBaseStore,
  DIALOG_INVOKER_CONFIG,
  DialogService,
  ICON_COMPONENT_CONFIG,
  IMAGE_UPLOADER_COMPONENT_CONFIG,
  provide,
  provideCacBase,
  TABLE_COMPONENT_CONFIG,
} from '@controladad/ng-base';
import { AppStore, AttachmentApiService, AuthStore, DialogExtendedService, FileType, ErrorInterceptor } from '@core';
import { inject } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PANEL_ICONS } from './icons';

export const provideCac = (type: string, environment: any) => [
  provideCacBase({
    applicationName: `lawazem-${type}`,
    environment: environment,
    apiBaseUrl: environment.apiBaseUrl,
    localization: {
      langs: ['en'],
    },
    icons: {
      names: PANEL_ICONS,
      directory: './assets/panel/icons',
    },
  }),

  { provide: DialogService, useClass: DialogExtendedService },
  { provide: AuthBaseStore, useClass: AuthStore },
  { provide: AppBaseStore, useClass: AppStore },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

  provide(ICON_COMPONENT_CONFIG, {
    size: '1.5rem',
    strokeWidth: 1.5,
  }),
  provide(TABLE_COMPONENT_CONFIG, {
    pagination: { size: 10 },
  }),
  provide(DIALOG_INVOKER_CONFIG, {
    backdropBlur: 'sm',
  }),
  provide(IMAGE_UPLOADER_COMPONENT_CONFIG, () => {
    const attachmentApi = inject(AttachmentApiService);

    return {
      label: 'Image',
      accept: '.png,.jpeg,.jpg,.webp',
      uploadFn: (file: File) => attachmentApi.upload(file),
      fetchFn: (value: any) => value?.imageUrl,
    };
  }),
];
